const initHeaderHeight = () => {
  // デバイスの高さを取得して変数化
  window.setDeviceHeight = () => {
    const deviceHeight = window.innerHeight;
    document.body.style.setProperty('--device-height', `${deviceHeight}px`);
  };


  window.setHeaderHeight = () => {
    const header = document.querySelector('.site-header');
    const announcement = document.querySelector('.announcement-bar');
    if (!header) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    const headerHeight = header.offsetHeight;
    const announcementHeight = announcement && scrollTop <= 0 ? announcement.offsetHeight : 0;

    document.body.style.setProperty('--header-height', `${headerHeight}px`);
    document.body.style.setProperty('--announcement-height', `${announcementHeight}px`);
    const headerWidth = header.offsetWidth;
    document.body.style.setProperty('--header-width', `${headerWidth}px`);
  };

  // 初期表示時に実行
  window.setHeaderHeight();
  window.setDeviceHeight();

  // スクロール時に実行 
  window.addEventListener('scroll', () => {
    window.setHeaderHeight();
  });

  // リサイズ時に実行
  window.addEventListener('resize', () => {
    window.setHeaderHeight(); 
    window.setDeviceHeight();
  });
};

// ヘッダーのスクロール制御を実装
const initHeaderScroll = () => {
  const header = document.querySelector('.site-header');
  if (!header) return;
  
  let lastScrollTop = 0;
  let isHeaderVisible = true;
  const scrollThreshold = 50; // スクロールしきい値を小さく設定
  
  // スクロールイベントのハンドラー
  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isScrollingDown = scrollTop > lastScrollTop;
    
    // ページ最上部では通常表示
    if (scrollTop <= 0) {
      header.classList.remove('site-header--fixed', 'site-header--hidden');
      isHeaderVisible = true;
    } 
    // 下スクロールの場合
    else if (isScrollingDown) {
      // 下スクロール時は常に非表示
      header.classList.add('site-header--fixed', 'site-header--hidden');
      isHeaderVisible = false;
    } 
    // 上スクロールの場合
    else if (!isScrollingDown && scrollTop > scrollThreshold) {
      // 上スクロール時のみ表示
      header.classList.add('site-header--fixed');
      header.classList.remove('site-header--hidden');
      isHeaderVisible = true;
    }
    
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Safari対策：負の値にならないように
  };
  
  // 最適化のためにスクロールイベントを間引く
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  // 初期状態では通常表示
  handleScroll();
};

document.addEventListener('DOMContentLoaded', () => {
  initHeaderHeight();
  initHeaderScroll();
});


// メガメニューの制御を追加
const initMegaMenu = () => {
  const menuTriggers = document.querySelectorAll('[data-menu-target]');
  const megaMenu = document.querySelector('#Main-Navigation-Body');
  const menuBackground = document.querySelector('#Main-Navigation-background');
  const menuContents = document.querySelectorAll('[data-menu-id]');
  const header = document.querySelector('.site-header');
  let isOpen = false;

  // メニューを開く
  const openMenu = (targetId) => {
    megaMenu.classList.add('is-open');
    menuBackground.classList.add('is-open');
    document.body.classList.add('no-scroll');
    header.classList.add('navigation-open');
    isOpen = true;

    // メニューコンテンツの表示切り替え
    menuContents.forEach(content => {
      const menuId = content.getAttribute('data-menu-id');
      content.style.display = menuId === targetId ? 'block' : 'none';
    });

    if(targetId === 'account'){
      megaMenu.classList.add('c-global-nav--account');
    }else{
      megaMenu.classList.remove('c-global-nav--account');
    }

    if(window.setHeaderHeight){
      window.setHeaderHeight();
    }
  };

  // メニューを閉じる
  const closeMenu = () => {
    megaMenu.classList.remove('is-open');
    menuBackground.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    header.classList.remove('navigation-open');
    isOpen = false;

    // トリガーボタンのアクティブ状態を解除
    menuTriggers.forEach(trigger => {
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    });
    
    // megaMenu.classList.remove('c-global-nav--account');

    if(window.setHeaderHeight){
      window.setHeaderHeight();
    }
  };

  // トリガーボタンのクリックイベント
  menuTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const targetId = trigger.getAttribute('data-menu-target');
      const isCurrentlyOpen = trigger.classList.contains('is-open');

      // 他のトリガーのアクティブ状態を解除
      menuTriggers.forEach(t => {
        t.classList.remove('is-open');
        t.setAttribute('aria-expanded', 'false');
      });

      if (!isCurrentlyOpen) {
        // 新しいメニューを開く
        trigger.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        openMenu(targetId);
      } else {
        // メニューを閉じる
        closeMenu();
      }
    });
  });

  // 背景クリックでメニューを閉じる
  menuBackground.addEventListener('click', () => {
    closeMenu();
  });

  // ESCキーでメニューを閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) {
      closeMenu();
    }
  });

  // メガメニュー外のクリックでメニューを閉じる
  document.addEventListener('click', (e) => {
    if (isOpen && !megaMenu.contains(e.target) && !e.target.hasAttribute('data-menu-target')) {
      closeMenu();
    }
  });
};

// メニュースクロール機能の実装
const initMenuScroll = () => {
  const scrollButtons = document.querySelectorAll('[data-scroll-menu]');
  
  scrollButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      
      // 対象のメニューハンドルを取得
      const targetHandle = button.getAttribute('data-scroll-menu');
      // 対応するメニューコンテナを取得
      const menuContainer = document.querySelector(`[data-menu-id="${targetHandle}"]`);
      
      if (!menuContainer) return;

      // スクロール可能な要素を取得
      const scrollContainer = menuContainer.querySelector('.c-global-mega-menu__item-content');
      
      if (!scrollContainer) return;

      // スムーズスクロールを実行
      const scrollToBottom = () => {
        const startPosition = scrollContainer.scrollTop;
        const targetPosition = scrollContainer.scrollHeight - scrollContainer.clientHeight;
        const distance = targetPosition - startPosition;
        const duration = 500; // スクロール時間（ミリ秒）
        let start = null;

        const animation = currentTime => {
          if (!start) start = currentTime;
          const progress = currentTime - start;
          const percentage = Math.min(progress / duration, 1);

          // イージング関数（ease-out）
          const easing = t => 1 - Math.pow(1 - t, 3);
          
          // スクロール位置を更新
          scrollContainer.scrollTop = startPosition + (distance * easing(percentage));

          // アニメーションが完了していない場合は続行
          if (percentage < 1) {
            requestAnimationFrame(animation);
          }
        };

        requestAnimationFrame(animation);
      };

      scrollToBottom();
    });
  });
};

const initDrawer = () => {
  const drawerMenuToggle = document.querySelector('#drawer-menu-toggle');
  const header = document.querySelector('.site-header');
  const drawerContainer = document.querySelector('.drawer-menu');
  const drawerBtns = document.querySelectorAll('[data-drawer-target]');
  const closeBtns = document.querySelectorAll('[data-drawer-close-btn]');
  let isOpen = false;

  // ドロワーメニューの開閉
  drawerMenuToggle.addEventListener('change', (event) => {
    if (drawerMenuToggle.checked === true) {
      console.log(drawerMenuToggle.checked);
      header.classList.add('navigation-open');
      isOpen = true;
      document.body.classList.add('no-scroll');
      
      // 初期表示では最初のメニューを表示
      const firstMainMenu = document.querySelector('.mobile-nav.is-open');
      if (firstMainMenu) {
        // 現在のレベルをリセット
        drawerContainer.setAttribute('data-current-level', '1');
      }
      
    } else {
      header.classList.remove('navigation-open');
      isOpen = false;
      document.body.classList.remove('no-scroll');
      resetAllDrawers();
    }
  });

  // サブドロワーメニューの制御
  drawerBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // ターゲットドロワーID取得
      const targetId = btn.getAttribute('data-drawer-target');
      const targetDrawer = document.querySelector(`[data-drawer-id="${targetId}"]`);
      const currentLevel = btn.getAttribute('data-level');
      const nextLevel = parseInt(currentLevel, 10) + 1;
      
      if (!targetDrawer) return;
      
      // 現在のレベルを設定
      drawerContainer.setAttribute('data-current-level', nextLevel);
      
      // ターゲットドロワーを表示（他のis-openクラスは削除しない）
      targetDrawer.classList.add('is-open');
    });
  });
  
  // 戻るボタン（閉じるボタン）の制御
  closeBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      
      // 戻るボタンの1つ前のis-openクラスを持つ要素を取得
      const targetNav = btn.previousElementSibling.matches('.is-open') ? btn.previousElementSibling : null;
      console.log("targetNav",targetNav);
      if (targetNav) {
        // 現在のドロワーを閉じる
        targetNav.classList.remove('is-open');
        
        // 現在のレベルを設定し直す
        const parentLevel = parseInt(targetNav.getAttribute('data-level'), 10) - 1;
        drawerContainer.setAttribute('data-current-level', parentLevel);
        
        // レベル2からレベル1に戻る場合、メインメニューを表示
        if (parentLevel === 1) {
          document.querySelector('.mobile-nav.is-open').classList.add('is-open');
        }
      }
    });
  });
  
  // // 閉じるボタンの制御
  // const closeBtn = document.querySelector('.drawer-menu__close-btn');
  // if (closeBtn) {
  //   closeBtn.addEventListener('click', () => {
  //     drawerMenuToggle.checked = false;
  //     header.classList.remove('navigation-open');
  //     isOpen = false;
  //     document.body.classList.remove('no-scroll');
  //     resetAllDrawers();
  //   });
  // }
  
  // すべてのドロワーをリセット
  function resetAllDrawers() {
    drawerContainer.setAttribute('data-current-level', '1');
    document.querySelectorAll('[data-drawer-id]').forEach(drawer => {
      if (!drawer.classList.contains('is-open') || drawer.getAttribute('data-level') !== '1') {
        drawer.classList.remove('is-open');
      }
    });
  }

  // タイトルリンクのクリックイベント処理（ページ遷移を許可）
  const titleLinks = document.querySelectorAll('.mobile-nav__item--title__link');
  titleLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.stopPropagation();
      // リンクのhrefに遷移する（デフォルトの動作を許可）
      // preventDefault()を呼ばないことで、通常のリンク遷移が実行される
    });
  });
};

// アナウンスメントバーのローテーション機能
const initAnnouncementRotation = () => {
  const rotationContainer = document.querySelector('[data-announcement-rotation]');
  if (!rotationContainer) return;

  const messages = rotationContainer.querySelectorAll('.announcement-bar__message--rotation');
  if (messages.length <= 1) return;

  // 親のリンク要素を取得
  const parentLink = rotationContainer.closest('.announcement-bar__link');

  let currentIndex = 0;
  // data属性からローテーション間隔を取得（デフォルトは3秒）
  const rotationInterval = parseInt(rotationContainer.getAttribute('data-rotation-interval')) || 3000;
  let rotationTimer = null;

  // コンテナの高さと幅を固定（最も高い/広いメッセージに合わせる）
  const setContainerDimensions = () => {
    let maxHeight = 0;
    let maxWidth = 0;
    const isPC = window.innerWidth >= 750;
    
    // PCサイズの場合のみ幅を測定
    if (isPC) {
      messages.forEach(message => {
        // 一時的に表示して高さと幅を測定
        const originalClasses = message.className;
        const originalStyles = {
          position: message.style.position,
          opacity: message.style.opacity,
          transform: message.style.transform,
          display: message.style.display,
          visibility: message.style.visibility,
          width: message.style.width,
          whiteSpace: message.style.whiteSpace,
          zIndex: message.style.zIndex
        };
        
        // すべてのスタイルをリセットして測定
        message.className = 'announcement-bar__message announcement-bar__message--rotation announcement-bar__message--active';
        message.style.position = 'relative';
        message.style.opacity = '1';
        message.style.transform = 'translateY(0)';
        message.style.display = 'block';
        message.style.visibility = 'visible';
        message.style.width = 'auto';
        message.style.whiteSpace = 'nowrap';
        message.style.zIndex = '-1';
        message.style.pointerEvents = 'none';
        
        // 強制的に再計算
        void message.offsetHeight;
        void message.offsetWidth;
        
        const height = message.scrollHeight;
        const width = message.scrollWidth;
        
        if (height > maxHeight) {
          maxHeight = height;
        }
        if (width > maxWidth) {
          maxWidth = width;
        }
        
        // 元に戻す
        message.className = originalClasses;
        Object.keys(originalStyles).forEach(key => {
          message.style[key] = originalStyles[key];
        });
        message.style.pointerEvents = '';
      });
      
      // 最大幅を設定（少し余裕を持たせる）
      if (maxWidth > 0) {
        rotationContainer.style.width = `${maxWidth + 2}px`;
        rotationContainer.style.maxWidth = '100%';
      }
    } else {
      // スマホサイズでは高さのみ測定
      messages.forEach(message => {
        const originalClasses = message.className;
        const originalStyles = {
          position: message.style.position,
          opacity: message.style.opacity,
          transform: message.style.transform,
          display: message.style.display,
          visibility: message.style.visibility
        };
        
        message.className = 'announcement-bar__message announcement-bar__message--rotation announcement-bar__message--active';
        message.style.position = 'relative';
        message.style.opacity = '1';
        message.style.transform = 'translateY(0)';
        message.style.display = 'block';
        message.style.visibility = 'hidden';
        message.style.width = '100%';
        
        void message.offsetHeight;
        
        const height = message.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
        
        message.className = originalClasses;
        Object.keys(originalStyles).forEach(key => {
          message.style[key] = originalStyles[key];
        });
      });
    }
    
    if (maxHeight > 0) {
      rotationContainer.style.minHeight = `${maxHeight}px`;
      if (isPC) {
        rotationContainer.style.height = 'auto';
      } else {
        rotationContainer.style.height = `${maxHeight}px`;
        rotationContainer.style.width = '100%';
      }
    }
  };

  const showMessage = (index) => {
    messages.forEach((message, i) => {
      if (i === index) {
        message.classList.remove('announcement-bar__message--hidden');
        message.classList.add('announcement-bar__message--active');
        
        // リンクのURLを更新
        if (parentLink && parentLink.tagName === 'A') {
          const linkUrl = message.getAttribute('data-link-url');
          if (linkUrl && linkUrl !== '') {
            parentLink.href = linkUrl;
            parentLink.style.pointerEvents = 'auto';
          } else {
            parentLink.href = '#';
            parentLink.style.pointerEvents = 'none';
          }
        }
      } else {
        message.classList.remove('announcement-bar__message--active');
        message.classList.add('announcement-bar__message--hidden');
      }
    });
  };

  const nextMessage = () => {
    currentIndex = (currentIndex + 1) % messages.length;
    showMessage(currentIndex);
  };

  // 初期表示と高さ・幅設定
  setContainerDimensions();
  showMessage(0);

  // ローテーション開始
  rotationTimer = setInterval(nextMessage, rotationInterval);

  // ページが非表示になったらタイマーを停止（パフォーマンス最適化）
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      if (rotationTimer) {
        clearInterval(rotationTimer);
        rotationTimer = null;
      }
    } else {
      // ページが再表示されたらタイマーを再開
      if (!rotationTimer) {
        rotationTimer = setInterval(nextMessage, rotationInterval);
      }
    }
  });

  // リサイズ時に高さ・幅を再計算
  let resizeTimer = null;
  window.addEventListener('resize', () => {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      setContainerDimensions();
    }, 250);
  });
};

// 全ての機能を初期化
document.addEventListener('DOMContentLoaded', () => {
  initHeaderHeight();
  initHeaderScroll();
  initMegaMenu();
  initMenuScroll();
  initDrawer();
  initAnnouncementRotation();
});

